import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICustomDynamicComponent } from 'ngx-property-grid';

@Component({
    selector: 'app-text-property',
    templateUrl: './text-property.component.html',
    styleUrls: ['./text-property.component.scss']
})
export class TextPropertyComponent implements ICustomDynamicComponent<string> {
    @Input() value: string;
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() labelClass: string;
    @Input() iconClass: string;

    onChange(data: any) {
        this.value = data.target.value || '';
        this.valueChange.emit(this.value);
    }
}
